const configured = import.meta.env.VITE_API_BASE_URL?.trim();

/** API origin without trailing slash. Empty string = same origin (proxy in dev). */
export function getApiBaseUrl() {
  if (!configured) {
    return '';
  }
  return configured.replace(/\/+$/, '');
}

export function apiUrl(path) {
  const base = getApiBaseUrl();
  if (!path.startsWith('/')) {
    return `${base}/${path}`;
  }
  return `${base}${path}`;
}
